export const MULTI_FILTER_KEYS = ['agent', 'desk', 'team', 'country', 'office', 'department', 'language', 'affiliate', 'salesStatus', 'retStatus'];
export const EMPTY_FILTERS = { search: '', country: [], office: [], agent: [], language: [], department: [], desk: [], team: [], ftd: '', affiliate: [], salesStatus: [], retStatus: [], refSearch: '', balanceMin: '', balanceMax: '', regFrom: '', regTo: '', modFrom: '', modTo: '', active: '', needsUpdate: '' };

export function sanitizeFilters(value) {
  const source = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  return Object.fromEntries(Object.keys(EMPTY_FILTERS).map(key => {
    const raw = source[key];
    if (MULTI_FILTER_KEYS.includes(key)) {
      const values = Array.isArray(raw) ? raw : [raw];
      return [key, [...new Set(values.filter(v => typeof v === 'string').map(v => v.trim()).filter(Boolean))]];
    }
    if (['ftd', 'active', 'needsUpdate'].includes(key)) {
      return [key, [true, false, 'true', 'false'].includes(raw) ? String(raw) : ''];
    }
    if (['balanceMin', 'balanceMax'].includes(key)) {
      return [key, raw !== null && raw !== undefined && String(raw).trim() !== '' && Number.isFinite(Number(raw)) ? String(raw) : ''];
    }
    return [key, typeof raw === 'string' ? raw.trim() : ''];
  }));
}

export function activeFilterEntries(filters) {
  return Object.entries(sanitizeFilters(filters)).filter(([, value]) => Array.isArray(value) ? value.length > 0 : value !== '');
}

export function sanitizeFilterPresets(value) {
  if (!Array.isArray(value)) return [];

  const seenIds = new Set();
  return value.flatMap((preset, index) => {
    if (!preset || typeof preset !== 'object' || Array.isArray(preset)) return [];
    const name = typeof preset.name === 'string' ? preset.name.trim().slice(0, 60) : '';
    if (!name) return [];

    const candidateId = typeof preset.id === 'string' && preset.id.trim()
      ? preset.id.trim().slice(0, 100)
      : `preset-${index + 1}`;
    let id = candidateId;
    let suffix = 2;
    while (seenIds.has(id)) id = `${candidateId}-${suffix++}`;
    seenIds.add(id);

    return [{ id, name, filters: sanitizeFilters(preset.filters) }];
  });
}
